import Stack from '@zenbusiness/zui/Stack';

export default function Form(props) {
  return (
    <Stack
      as="form"
      noValidate // Disable HTML OOTB validation
      role="form"
      {...props}
    />
  );
}
